import { ICON_COLOR } from '@zep-us/zus/tokens';
import { Tooltip } from '@/components/ui/Tooltip';
import { MapFillIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
import { useBuildInfoContext } from '../context/BuildInfoProvider';
import { useShowMapTemplateModal } from '../features/map-selection';
import { useBuildFormContext } from '../form/schema';
export const BuildHeaderMapTemplateButton = () => {
  const {
    canEditQuiz,
    mapTemplates
  } = useBuildInfoContext();
  const {
    watch
  } = useBuildFormContext();
  const templateId = watch('templateId');
  const isLocked = !canEditQuiz;
  const selectedMapTemplate = mapTemplates?.find(m => m.templateId === templateId);
  const selectedMapTemplateImageUrl = selectedMapTemplate?.thumbnailImage;
  const {
    open
  } = useShowMapTemplateModal();
  return <Tooltip content={'맵은 변경할 수 없어요'} side="bottom" className={cn('hidden', isLocked && 'hidden mobile-lg:block')} trigger={<button onClick={() => {
    if (isLocked) {
      return;
    }
    void open({
      from: 'header_map_button',
      isChange: !!templateId
    });
  }} className={cn('group relative shrink-0 overflow-hidden h-[30px] border rounded-sm p-4xs w-[42px] flex justify-center items-center bg-neutral', 'hidden mobile-lg:flex', !isLocked && 'hover:bg-alternative hover:ring-opacity-black-3 hover:ring-2 hover:ring-offset-2', selectedMapTemplateImageUrl && 'border-none', isLocked && 'cursor-default')} aria-label="맵 템플릿 변경">
          {selectedMapTemplateImageUrl && <>
              <img src={selectedMapTemplateImageUrl} alt="선택된 맵 템플릿" className="absolute left-0 top-0 size-full object-cover " />
              {!isLocked && <div className="absolute inset-0 hidden bg-dimmed group-hover:block" />}
            </>}
          <MapFillIcon size="xs" className={cn('hidden z-30', !selectedMapTemplateImageUrl && 'block', !isLocked && 'group-hover:block')} fill={selectedMapTemplateImageUrl ? ICON_COLOR.inverse : ICON_COLOR.assistive} />
        </button>} data-sentry-element="Tooltip" data-sentry-component="BuildHeaderMapTemplateButton" data-sentry-source-file="BuildHeaderMapTemplateButton.tsx"></Tooltip>;
};